module.exports = __webpack_public_path__ + "79b58175343190550489efe46a7f1138.woff";